import _ from "lodash";

export const menuNames = {
  RAG: "Recommend a grant",
  GA: "Grant Agreements",
  MAC: "Make a contribution",
  RAE: "Recommend an exchange",
  VEG: "View and Edit Grant"
};

export const freezeEntity = {
  "10 Day - Block All Transactions": ["RAG", "GA", "MAC", "RAE", "VEG"],
  "10 Day - Block All Grants and Transfers": ["RAG", "GA", "VEG"],
  "Written Request - Block All Transactions": [
    "RAG",
    "GA",
    "MAC",
    "RAE",
    "VEG"
  ],
  "Written Request - Block Grants and Transfers": ["RAG", "GA", "VEG"],
  "Legal - Block All Transactions": ["RAG", "GA", "MAC", "RAE"],
  "Legal - Block All Grants and Transfers": ["RAG", "GA", "VEG"],
  "Other - Block All Transactions": ["RAG", "GA", "MAC", "RAE", "VEG"],
  "0ther - Block All Grants and Transfers": ["RAG", "GA", "VEG"],
  "POA - Block Grants and Transfers": ["RAG", "GA", "VEG"]
};

export const freezeAccount = {
  "Excessive exchanges - block exchanges": ["RAE"],
  "Other - block all transactions except contributions": [
    "RAG",
    "GA",
    "RAE",
    "VEG"
  ],
  "Block redemptions - grants and transfers": ["RAG", "GA", "VEG"],
  "Block all transactions, including contributions": [
    "RAG",
    "GA",
    "MAC",
    "RAE",
    "VEG"
  ],
  "10 Day - Block All Transactions": ["RAG", "GA", "MAC", "RAE", "VEG"],
  "10 Day - Block All Redemptions": ["RAG", "GA", "VEG"],
  "Written Request - Block All Transactions": [
    "RAG",
    "GA",
    "MAC",
    "RAE",
    "VEG"
  ],
  "Written Request - Block Grants and Transfers": ["RAG", "GA", "VEG"],
  "Legal - Block All Transactions": ["RAG", "GA", "MAC", "RAE"],
  "Legal - Block All Grants and Transfers": ["RAG", "GA", "VEG"],
  "Other - Block All Transactions": ["RAG", "GA", "MAC", "RAE", "VEG"],
  "Other - Block All Grants and Transfers": ["RAG", "GA", "VEG"],
  "POA - Block Redemptions": ["RAG", "GA", "VEG"]
};

export const getFreezeFeaturesList = (partyFreezes = [], freezes = []) => {
  let blockedElementEntityLevel = [];
  let blockedElementAccountLevel = [];
  // party freezes can be null
  partyFreezes &&
    partyFreezes.forEach(freeze => {
      blockedElementEntityLevel = blockedElementEntityLevel.concat(
        freezeEntity[freeze]
      );
    });
  // freezes can be null
  freezes &&
    freezes.forEach(freeze => {
      blockedElementAccountLevel = blockedElementAccountLevel.concat(
        freezeAccount[freeze.trim()]
      );
    });

  return _.union(blockedElementEntityLevel, blockedElementAccountLevel);
};
